export var WorkspaceRestoreMode;
(function (WorkspaceRestoreMode) {
    WorkspaceRestoreMode["WORKSPACE_RESTORE_MODE_UNSPECIFIED"] = "WORKSPACE_RESTORE_MODE_UNSPECIFIED";
    WorkspaceRestoreMode["WORKSPACE_RESTORE_MODE_RENAME"] = "WORKSPACE_RESTORE_MODE_RENAME";
    WorkspaceRestoreMode["WORKSPACE_RESTORE_MODE_OVERWRITE"] = "WORKSPACE_RESTORE_MODE_OVERWRITE";
})(WorkspaceRestoreMode || (WorkspaceRestoreMode = {}));
